import {useState, useEffect} from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import {useRegistration} from '../../../contexts/RegistrationContext';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import styled from 'styled-components';
import config from '../../../config';
import {
  SubInner,
  TabHeader,
  SectionTitle,
  FormInput,
  RequiredLabel,
  InputLabel,
} from '../../atoms/CommonParts';
import {ScannedDevice, StepWrap} from '.';
import {useApp} from '../../../contexts/AppContext';
import {
  useCustomDialog,
  ButtonLayout,
} from '../../../contexts/CustomDialogContext';
import SelectModal, {SelectedLabel} from '../../organisms/SelectModal';
import {NotLoginedHeaderArea} from '../../organisms/CommonParts';

const Page = styled.div``;

const Buttons = styled.div`
  margin: 45px 0 0px;
  display: flex;
  gap: 30px;

  @media ${config.layout.wide} {
    justify-content: center;
  }
  button {
    @media ${config.layout.wide} {
      max-width: 140px;
      flex: 0 1 auto;
    }
  }
`;

const ScannedDeviceBlockElm = styled.div`
  margin-top: 40px;
  border-top: 1px solid #000000;
  border-bottom: 1px solid #000000;
  width: calc(100% + 40px);
  position: relative;
  left: -20px;
  padding: 20px 20px 30px;
  @media ${config.layout.wide} {
  }

  & > h3 {
    font-size: 16px;
    font-weight: bold;
    line-height: 1;
    margin-bottom: 20px;
  }
`;

const ScannedDeviceDataElm = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ScannedDeviceImageArea = styled.div`
  height: 170px;
  width: 40.6%;
  background-color: #F8F8F8;
  background-size: auto 130px;
  background-position: center;
  background-repeat: no-repeat;
  flex: 0 2 auto;
  @media ${config.layout.wide} {
    width: 34.8%;
  }
`;
const ScannedDeviceInfoArea = styled.div`
  width: 59.4%;
  flex: 1 1 auto;
  padding: 0 0 0 17px;
  @media ${config.layout.wide} {
    width: 65.2%;
  }
`;

const ScannedDeviceInfo = styled.div`
  user-select: auto;
  padding-bottom: 10px;
  padding-top: 10px;
  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
  h4 {
    font-size: 14px;
    line-height: 19px;
    font-weight: bold;
    white-space: nowrap;
  }

  span {
    display: block;
    font-size: 12px;
    line-height: 1.2;
    font-weight: 500;
    margin-top: 2px;
    white-space: nowrap;
  }

  border-bottom: 1px solid #000000;
  @media ${config.layout.wide} {
    display: flex;
    align-items: center;
    h4 {
      width: 130px;
      flex: 0 0 auto;
      padding-left: 10px;
    }
    span {
      flex: 1 1 auto;
    }
  }
`;

const DeviceBlockElm = styled.div``;

const DeviceModelArea = styled.div`
  margin-top: 30px;
  @media ${config.layout.wide} {
    margin-top: 43px;
  }
`;

const DeviceModelAreaLabel = styled.span`
  font-size: 14px;
  font-weight: bold;
  line-height: 1;

  @media ${config.layout.wide} {
    font-size: 16px;
  }
`;

const DeviceModelAreaValue = styled.span`
  user-select: auto;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  margin-left: 25px;
  @media ${config.layout.wide} {
    font-size: 16px;
  }

  &.error {
    color: #FF7323;
  }
`;

function DeviceBlock({}) {
  const registration = useRegistration();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const device = registration.state.devices[0];
  const rooms = registration.state.rooms || [];
  const [model, setModel] = useState({
    error: !device.valid && device.customer_id.length == 15,
    name: (device.valid && device.device_name) || '',
  });

  let selectedIndex = -1;
  let r = rooms.find((_r, i) => {
    if (_r.new_room_id == device.new_room_id) {
      selectedIndex = i;
      return true;
    }
    return false;
  });
  if (selectedIndex < 0) {
    selectedIndex = 0;
    r = rooms[0];
  }

  const onClick = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const itemSelect = (index) => {
    setModalIsOpen(false);
    device.new_room_id = rooms[index].new_room_id;
    registration.dispatch({
      type: 'set_devices',
      devices: [device],
    });
  };

  const validateSerialCode = (event) => {
    let value = event.target.value.trim().toUpperCase();
    if (device.serial_code == value) {
      return;
    }
    registration.dispatch({
      type: 'set_devices',
      devices: [
        {
          ...device,
          serial_code: value,
        },
      ],
    });
  };

  const validateCustomerID = (event) => {
    let value = event.target.value.trim().toUpperCase();

    if (device.customer_id == value) {
      return;
    }

    if (/^[0-9a-f]{15}$/gi.test(value)) {
      (async function(value) {
        let validatedDevice = null;
        window.isValidating = true;
        try {
          validatedDevice = await registration.validate(value);
          console.log(validatedDevice);
        } catch (e) {
          validatedDevice = null;
        }
        window.isValidating = false;
        console.log(validatedDevice);
        if (validatedDevice && validatedDevice.device_name) {
          setModel({
            error: false,
            name: validatedDevice.device_name,
          });
          registration.dispatch({
            type: 'set_devices',
            devices: [
              {
                new_room_id: device.new_room_id,
                customer_id: value,
                device_name: validatedDevice.device_name,
                scanned: false,
                valid: true,
                is_others: validatedDevice.is_others,
              },
            ],
          });
        } else {
          setModel({
            error: true,
            name: '',
          });
          registration.dispatch({
            type: 'set_devices',
            devices: [
              {
                ...device,
                customer_id: value,
                device_name: '',
                scanned: false,
                valid: false,
                is_others: false,
              },
            ],
          });
        }
        console.log(validatedDevice);
      })(value);
      return;
    } else if (value.length >= 15) {
      setModel({
        error: true,
        name: '',
      });
      registration.dispatch({
        type: 'set_devices',
        devices: [
          {
            ...device,
            customer_id: value,
            device_name: '',
            scanned: false,
            valid: false,
            is_others: false,
          },
        ],
      });
    } else {
      setModel({
        error: false,
        name: '',
      });
      registration.dispatch({
        type: 'set_devices',
        devices: [
          {
            ...device,
            customer_id: value,
            device_name: '',
            scanned: false,
            valid: false,
            is_others: false,
          },
        ],
      });
    }
  };

  return (
      <DeviceBlockElm>
        <RequiredLabel/>
        <InputLabel required={false}>Room/Floor</InputLabel>
        <SelectedLabel onClick={onClick}>{r.name}</SelectedLabel>
        <SelectModal
            title="Room/Floor"
            candidates={rooms.map((c) => c.name)}
            selectedIndex={selectedIndex}
            closeModal={closeModal}
            modalIsOpen={modalIsOpen}
            itemSelect={itemSelect}
        />
        <DeviceModelArea>
          <DeviceModelAreaLabel>Device model</DeviceModelAreaLabel>
          {model.error ? (
              <DeviceModelAreaValue className="error">
                Invalid KUVO Device ID
              </DeviceModelAreaValue>
          ) : (
              <DeviceModelAreaValue>
                {model.name || '- - - - - - - - - - - - - -'}
              </DeviceModelAreaValue>
          )}
        </DeviceModelArea>

        <LabelWithInfo
            text={'KUVO Device ID'}
            labelclassname="room-field-label"
            style={{
              marginTop: 30,
              marginBottom: 20,
            }}
            /*required*/
        >
          <div>
            KUVO Device ID is fifteen digits of numbers and alphabets
            implemented per
            device.
          </div>
        </LabelWithInfo>
        <FormInput
            type="text"
            /*required*/
            name="customer_id"
            defaultValue={device.customer_id}
            onBlur={validateCustomerID}
            onChange={validateCustomerID}
            maxLength={15}
        />

        <LabelWithInfo
            text={'Serial no.'}
            labelclassname="room-field-label"
            style={{
              marginTop: 30,
              marginBottom: 20,
            }}
        >
          <div>
            A serial number is a unique twelve-digit per device displayed on the
            side or the bottom of the device.
            (e.g. AAAA000000AA)<br/>
            [CDJ-3000] You can preset it by scanning the QR code from the
            setting menu.
          </div>
        </LabelWithInfo>
        <FormInput
            type="text"
            name="serial_code"
            defaultValue={device.serial_code}
            maxLength={12}
            pattern={'^[0-9a-zA-Z]{12}$'}
            onBlur={validateSerialCode}
            onChange={validateSerialCode}
        />

      </DeviceBlockElm>
  );
}

function ScannedDeviceBlock({}) {
  const registration = useRegistration();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const device = registration.state.devices[0];
  const rooms = registration.state.rooms || [];

  let selectedIndex = -1;
  let r = rooms.find((_r, i) => {
    if (_r.new_room_id == device.new_room_id) {
      selectedIndex = i;
      return true;
    }
    return false;
  });
  if (selectedIndex < 0) {
    selectedIndex = 0;
    r = rooms[0];
  }

  const onClick = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const itemSelect = (index) => {
    setModalIsOpen(false);
    device.new_room_id = rooms[index].new_room_id;
    registration.dispatch({
      type: 'set_devices',
      devices: [device],
    });
  };

  return (
      <ScannedDeviceBlockElm>
        <h3>Room/Floor</h3>
        <SelectedLabel onClick={onClick}>{r.name}</SelectedLabel>
        <SelectModal
            title="Room/Floor"
            candidates={rooms.map((c) => c.name)}
            selectedIndex={selectedIndex}
            closeModal={closeModal}
            modalIsOpen={modalIsOpen}
            itemSelect={itemSelect}
        />
        <ScannedDeviceDataElm>
          <ScannedDeviceImageArea
              style={{
                backgroundImage: `url(${device.image_url})`,
              }}
          />
          <ScannedDeviceInfoArea>
            <ScannedDeviceInfo>
              <h4>Device model</h4>
              <span>{device.device_name}</span>
            </ScannedDeviceInfo>
            <ScannedDeviceInfo>
              <h4>KUVO Device ID</h4>
              <span>{device.customer_id}</span>
            </ScannedDeviceInfo>
            <ScannedDeviceInfo>
              <h4>Serial no.</h4>
              <span>{device.serial_code || '- - - - - - - - - -'}</span>
            </ScannedDeviceInfo>
          </ScannedDeviceInfoArea>
        </ScannedDeviceDataElm>
      </ScannedDeviceBlockElm>
  );
}

export default function RegistrationPageStep3() {
  const registration = useRegistration();
  const app = useApp();
  const [rooms, setRooms] = useState(registration.state.rooms || []);
  const {customDialog, errorDialogWithAPIError} = useCustomDialog();
  const navigate = useNavigate();

  useEffect(() => {
    app.hideHeader();
  }, []);

  async function handleSubmitCore() {
    if (registration.state.devices.some((d) => d.is_others)) {
      let confirm = await customDialog({
        description_element: (
            <span>
            This device is registered at another venue. <br className="pc"/>
            Do you want to switch it to your account?
          </span>
        ),
        buttons: [
          {
            label: 'No, cancel',
            positive: false,
          },
          {
            label: 'Yes',
            positive: true,
          },
        ],
      });
      if (confirm != 1) {
        return;
      }
    }

    try {
      let result = await registration.doRegister();
      console.log(result);
      navigate('/registration/completed', {
        state: {
          result,
        },
        replace: true,
      });
    } catch (e) {
      console.error(e);
      await errorDialogWithAPIError(e);
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    if (
        window.isValidating ||
        !registration.state.devices.length ||
        registration.state.devices.some((d) => {
          if (d.customer_id || d.serial_code) {
            return !d.valid;
          }
          // customer_id/serial_codeがなければ無視
          return false;
        })
    ) {
      return;
    }
    handleSubmitCore();
  }

  const onBack = (event) => {
    event.preventDefault();
    registration.dispatch({
      type: 'step2',
    });
  };

  const isValidSerialCode = (code) => {
    return !code || /^[0-9a-z]{12}$/i.test(code);
  };

  return (
      <Page>
        <NotLoginedHeaderArea
            style={{
              'margin-bottom': 40,
            }}
        />
        <ScannedDevice/>
        <SectionTitle
            style={{
              marginBottom: 20,
            }}
        >
          Setup
        </SectionTitle>
        <TabHeader
            buttons={[
              {
                title: 'Venue',
              },
              {
                title: 'Device',
                disabled: true,
              },
            ]}
            selectedIndex={0}
        />
        <SubInner>
          <form onSubmit={handleSubmit}>
            <StepWrap
                subTitle={'Register gateway device'}>
              {registration.state.scanned_device ? (
                  <ScannedDeviceBlock/>
              ) : (
                  <DeviceBlock/>
              )}

              <Buttons>
                <button
                    onClick={onBack}
                    className="light-button back-forward"
                    style={{
                      width: '100%',
                      textAlign: 'center',
                    }}
                >
                  <span>Back</span>
                </button>
                <button
                    type="submit"
                    className="dark-button back-forward primary"
                    style={{
                      width: '100%',
                      textAlign: 'center',
                    }}
                    disabled={
                        !registration.state.devices.length ||
                        registration.state.devices.some((d) => {
                          if (d.customer_id || d.serial_code) {
                            // 何かcustomer_id/serial_codeが入力されている
                            return !d.valid ||
                                !isValidSerialCode(d.serial_code);
                          } else {
                            // customer_id/serial_codeが入っていなければ、そのままスルー
                            return false;
                          }
                        })
                    }
                >
                  <span>Submit</span>
                </button>
              </Buttons>
            </StepWrap>
          </form>
        </SubInner>
      </Page>
  );
}
